var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("VerifyIdentityComponent", {
    ref: "verifyIdentityComponent",
    attrs: {
      "sub-title": _vm.$t("ENTER THE FOLLOWING DETAILS..."),
      "submit-button-text": _vm.$t("Retrieve my Account"),
      title: _vm.$t("Retrieve my Account"),
    },
    on: { submit: _vm.onSubmit },
    scopedSlots: _vm._u([
      {
        key: "further-actions",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "mt-4 pointer" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "text-dark font-14",
                    attrs: { to: _vm.dashboardRoute },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("Skip for now")) + " ")]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }